import SearchBar from "components/base/SearchBar";
import { useState } from "react";

const ChooseAddressView = ({ options, onSelect }) => {
  const [searchText, setSearchText] = useState("");

  console.log("options", options);

  const finalOptions = options.filter((option) =>
    option.contact_address_inline
      .toLowerCase()
      .includes(searchText.toLowerCase()),
  );

  return (
    <div className="text-sm">
      <div>
        <div>
          <SearchBar value={searchText} onChange={setSearchText} />
        </div>

        <div className="-mx-2 mt-4">
          <table>
            <tbody>
              {finalOptions.map((option) => (
                <tr
                  key={option.id}
                  className="border-y cursor-pointer hover:text-sky-600"
                  onClick={() => onSelect(option)}
                >
                  <td>
                    #{option.id}. {option.contact_address_inline}
                    {option.x_studio_mt_address_id
                      ? ` MT#(${option.x_studio_mt_address_id})`
                      : ""}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ChooseAddressView;
